import React, { useRef, ReactNode } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

interface ScrollFadeHeadingProps {
  children: ReactNode;
  className?: string;
}

/**
 * Wraps a heading so it fades in as it enters the viewport, then subtly
 * dims (not fully disappears) as the user scrolls past it — a quiet,
 * editorial-feeling scroll interaction rather than a static reveal.
 */
const ScrollFadeHeading: React.FC<ScrollFadeHeadingProps> = ({ children, className }) => {
  const ref = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start 90%', 'end 15%'],
  });

  const opacity = useTransform(scrollYProgress, [0, 0.35, 0.75, 1], [0, 1, 1, 0.45]);
  const y = useTransform(scrollYProgress, [0, 0.35], [24, 0]);

  return (
    <motion.div ref={ref} style={{ opacity, y }} className={className}>
      {children}
    </motion.div>
  );
};

export default ScrollFadeHeading;
